/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const OrderItem = require('./order_item');
const OrderItemPrice = require('./order_item_price').default;
const Arranger = require('./arranger/arranger').default;
const R = require('ramda');

class Order {
  static initClass() {
    this.prototype.dateFormat = 'YYYY-MM-DD';
  }
  constructor(args, trip) {
    if (args == null) {
      args = {};
    }
    _.assign(this, args);
    this.createdAt = moment(args.created_at);
    this.confirmedAt = args.confirmed_at ? moment(args.confirmed_at) : undefined;
    this.gmoId = args.gmo_id;
    this.paymentTransactionId = args.payment_transaction_id;

    if (trip) {
      if (!this.flight_outword_date) {
        this.flight_outword_date = trip.checkin_date;
      }
      if (!this.flight_homeword_date) {
        this.flight_homeword_date = trip.checkout_date;
      }
      if (!this.hotel_checkin_date) {
        this.hotel_checkin_date = trip.checkin_date;
      }
      if (!this.hotel_checkout_date) {
        this.hotel_checkout_date = trip.checkout_date;
      }
      if (!this.outword_date) {
        this.outword_date = trip.checkin_date;
      }
      if (!this.homeword_date) {
        this.homeword_date = trip.checkout_date;
      }
      this.showFee = trip.showFee;
      this.billing = trip.billing;
    }

    if (typeof this.flight_outword_date === 'string') {
      this.flight_outword_date = moment(this.flight_outword_date);
    }
    if (typeof this.flight_homeword_date === 'string') {
      this.flight_homeword_date = moment(this.flight_homeword_date);
    }
    if (typeof this.hotel_checkin_date === 'string') {
      this.hotel_checkin_date = moment(this.hotel_checkin_date);
    }
    if (typeof this.hotel_checkout_date === 'string') {
      this.hotel_checkout_date = moment(this.hotel_checkout_date);
    }
    if (typeof this.outword_date === 'string') {
      this.outword_date = moment(this.outword_date);
    }
    if (typeof this.homeword_date === 'string') {
      this.homeword_date = moment(this.homeword_date);
    }

    if (!this.flight) {
      this.flight = '';
    }
    if (!this.hotel_name) {
      this.hotel_name = '';
    }
    if (!this.outword) {
      this.outword = '';
    }
    if (!this.homeword) {
      this.homeword = '';
    }

    this.orderItems = _.map(args.order_items, raw => new OrderItem(_.merge(raw, this._itemOptions())));
    this.orderItems = _.sortBy(this.orderItems, function (item) {
      if (item.startDate()) {
        return `${item.startDate().format('YYYYMMDDHHmm')}_${item.traceId}`;
      } else {
        return item.traceId;
      }
    });
    for (var item of Array.from(this.orderItems)) {
      item.order = this;
    }
    this.hotelItem =
      _.find(this.orderItems, item => item.id === dig(args.hotel_item, 'id')) ||
      new OrderItem(this._itemOptions());
    this.outwordItem =
      _.find(this.orderItems, item => item.id === dig(args.outword_item, 'id')) ||
      new OrderItem(this._itemOptions());
    this.homewordItem =
      _.find(this.orderItems, item => item.id === dig(args.homeword_item, 'id')) ||
      new OrderItem(this._itemOptions());
    this.flightItem =
      _.find(this.orderItems, item => item.id === dig(args.flight_item, 'id')) ||
      new OrderItem(this._itemOptions());
    this.flightItem.price.sectionNum = 2;

    this.deletedItems = [];

    // 右ナビチェック用
    this.checkedAt = args.checked_at ? moment(args.checked_at) : null;
    this.checker = args.checker ? new Arranger(args.checker) : null;

    // 仕訳入力確認用
    this.journalCreatedAt = args.journal_created_at ? moment(args.journal_created_at) : null;
    this.journalCreator = args.journal_creator ? new Arranger(args.journal_creator) : null;
  }

  allOrderItems() {
    return _.sortBy(this.orderItems, item => item.seqNum);
  }

  otherOrderItems() {
    const ids = _.compact(
      _.map([this.flightItem, this.hotelItem, this.outwordItem, this.homewordItem], item => item && item.id)
    );
    const others = _.reject(this.orderItems, item => _.includes(ids, item.id));
    return _.sortBy(others, item => item.seqNum);
  }

  hotelTotalPrice() {
    const prices = _.map(this.orderItems, function (item) {
      if (item.isHotelOnly()) {
        if (item.showFee) {
          return item.price.price + item.price.margin.amount;
        } else {
          return item.price.price;
        }
      } else {
        return 0;
      }
    });
    return _.sum(prices);
  }

  flightTotalPrice() {
    const prices = _.map(this.orderItems, function (item) {
      if (item.isForeignAirOnly()) {
        if (item.showFee) {
          return item.price.price + item.price.margin.amount;
        } else {
          return item.price.price;
        }
      } else {
        return 0;
      }
    });
    return _.sum(prices);
  }

  outwordTotalPrice() {
    if (_.isEmpty(dig(this.outwordItem, 'elements'))) {
      if (this.showFee) {
        return this.outword_price + this.outword_fee;
      } else {
        return this.outword_price;
      }
    } else {
      return this.outwordItem.price.totalPrice();
    }
  }

  homewordTotalPrice() {
    if (_.isEmpty(dig(this.homewordItem, 'elements'))) {
      if (this.showFee) {
        return this.homeword_price + this.homeword_fee;
      } else {
        return this.homeword_price;
      }
    } else {
      return this.homewordItem.price.totalPrice();
    }
  }

  domesticAirTotalPrice() {
    const prices = _.map(this.orderItems, function (item) {
      if (item.isDomesticAirOnly()) {
        if (item.showFee) {
          return item.price.price + item.price.margin.amount;
        } else {
          return item.price.price;
        }
      } else {
        return 0;
      }
    });
    return _.sum(prices);
  }

  shinTotalPrice() {
    const prices = _.map(this.orderItems, function (item) {
      if (item.isShinkansenOnly()) {
        if (item.showFee) {
          return item.price.price + item.price.margin.amount;
        } else {
          return item.price.price;
        }
      } else {
        return 0;
      }
    });
    return _.sum(prices);
  }

  otherTotalPrice() {
    if (this.orderItems.length > 0) {
      const prices = _.map(this.orderItems, item => {
        if (item.isOtherOnly()) {
          if (item.showFee) {
            return this.homeword_price + this.homeword_fee;
          } else {
            return this.homeword_price;
          }
        } else {
          return 0;
        }
      });
      return _.sum(prices);
    } else {
      return 0;
    }
  }

  totalPrice() {
    let p;
    if (this.orderItems.length > 0) {
      p = _.sumBy(this.orderItems, item => item.price.price);
      if (this.showFee) {
        p += _.sumBy(this.orderItems, item => item.price.margin.amount);
      }
    } else {
      p =
        this.flightTotalPrice() +
        this.domesticAirTotalPrice() +
        this.shinTotalPrice() +
        this.otherTotalPrice() +
        this.hotelTotalPrice();

      // old data compatibility
      if (this.shinkansen_fee) {
        p += this.shinkansen_fee;
      }
      if (this.domestic_air_fee) {
        p += this.domestic_air_fee;
      }
      if (this.foreign_air_fee) {
        p += this.foreign_air_fee;
      }
    }

    return p;
  }

  totalPriceWithAll() {
    return _.sumBy(this.orderItems, item => item.totalPriceWithAll());
  }

  totalMarginAmount() {
    const filteredItems = _.filter(this.orderItems, item => item.elements.length > 0);
    if (filteredItems.length > 0 && this.showFee) {
      return _.sumBy(filteredItems, item => item.price.margin.amount);
    } else {
      return 0;
    }
  }

  cancelFee() {
    let p;
    const filteredItems = _.filter(
      this.orderItems,
      item => item.elements.length > 0 && Object.keys(item.cancelCharges).length !== 0
    );
    if (filteredItems.length > 0) {
      p = _.sumBy(filteredItems, item => item.price.price);
      if (this.showFee) {
        p += _.sumBy(filteredItems, item => item.price.margin.amount);
      }
    } else {
      p = this.cancel_fee;
    }

    return p;
  }

  isCanceled() {
    const filteredItems = _.filter(
      this.orderItems,
      item => item.elements.length > 0 && Object.keys(item.cancelCharges).length !== 0
    );

    // orderの値が承認が必要な場合cancel_feeは0、必要ではない場合cancel_feeはnull
    return (this.cancel_fee !== null && this.cancel_fee !== 0) || filteredItems.length > 0;
  }

  isTicketingExpired() {
    const expired_order_items = _.filter(this.orderItems, item => item.isTicketingExpired());
    return expired_order_items.length > 0;
  }

  flightDate() {
    return this.flight_outword_date.format('M月D日') + '〜' + this.flight_homeword_date.format('M月D日');
  }

  stayDate() {
    return this.hotel_checkin_date.format('M月D日') + '〜' + this.hotel_checkout_date.format('M月D日');
  }

  startDate() {
    const dates = _.compact(_.map(this.orderItems, item => item.startDate()));
    return _.first(_.sortBy(dates, d => d.toDate()));
  }

  endDate() {
    const dates = _.compact(_.map(this.orderItems, item => item.endDate()));
    return _.last(_.sortBy(dates, d => d.toDate()));
  }

  setFlight(value) {
    this.flight = value;
    return app.render();
  }

  setFlightPrice(value) {
    this.flight_price = sanitizePrice(value);
    return app.render();
  }

  setFlightFee(value) {
    this.flight_fee = sanitizePrice(value);
    return app.render();
  }

  setFlightOutwordDate(value) {
    this.flight_outword_date = value;
    return app.render();
  }

  setFlightHomewordDate(value) {
    this.flight_homeword_date = value;
    return app.render();
  }

  setHotelName(value) {
    this.hotel_name = value;
    return app.render();
  }

  setHotelPrice(value) {
    if (value !== '0') {
      this.hotel_price = sanitizePrice(value);
    } else {
      this.hotel_price = parseInt(value);
    }
    return app.render();
  }

  setHotelCheckinDate(value) {
    this.hotel_checkin_date = value;
    return app.render();
  }

  setHotelCheckoutDate(value) {
    this.hotel_checkout_date = value;
    return app.render();
  }

  setOutword(value) {
    this.outword = value;
    return app.render();
  }

  setOutwordPrice(value) {
    this.outword_price = sanitizePrice(value);
    return app.render();
  }

  setOutwordFee(value) {
    this.outword_fee = sanitizePrice(value);
    return app.render();
  }

  setOutwordDate(value) {
    this.outword_date = value;
    return app.render();
  }

  setHomeword(value) {
    this.homeword = value;
    return app.render();
  }

  setHomewordPrice(value) {
    this.homeword_price = sanitizePrice(value);
    return app.render();
  }

  setHomewordFee(value) {
    this.homeword_fee = sanitizePrice(value);
    return app.render();
  }

  setHomewordDate(value) {
    this.homeword_date = value;
    return app.render();
  }

  removeOldFees() {
    this.foreign_air_fee = 0;
    this.domestic_air_fee = 0;
    return (this.shinkansen_fee = 0);
  }

  validationErrors() {
    const targetItems = _.filter(this.orderItems, item => item.isEditing);
    return _.map(targetItems, item => item.validationErrors());
  }

  updateParams() {
    const targetItems = _.filter(this.orderItems, item => item.isEditing);
    return {
      order_items: _.map(targetItems, item => item.updateParams()),
      deleted_trace_ids: _.map(this.deletedItems, item => item.traceId),
      order_items_updated_at: this.orderItemsUpdatedAt()
    };
  }

  // order_itemのtrace_idとupdated_atを（競合チェック用）に設定
  orderItemsUpdatedAt() {
    const timestampData = _.map(this.orderItems, function (item) {
      if (item.traceId && item.updatedAt) {
        // updatedAtが既に文字列の場合はそのまま使用、momentオブジェクトの場合はformat()
        const updatedAtValue =
          typeof item.updatedAt === 'string'
            ? item.updatedAt
            : moment.isMoment(item.updatedAt)
            ? item.updatedAt.format()
            : String(item.updatedAt);

        return {
          trace_id: item.traceId,
          updated_at: updatedAtValue
        };
      } else {
        return null;
      }
    });

    return _.compact(timestampData);
  }

  flightItemDescription() {
    if (!_.isEmpty(dig(this.flightItem, 'elements'))) {
      return `\
---
[海外]
${this.flightItem.description()}\
`;
    }
  }

  hotelItemDescription() {
    if (!_.isEmpty(dig(this.hotelItem, 'elements'))) {
      return `\
---
${this.hotelItem.description()}\
`;
    }
  }

  outwordItemDescription() {
    if (!_.isEmpty(dig(this.outwordItem, 'elements'))) {
      return `\
---
[往路]
${this.outwordItem.description()}\
`;
    }
  }

  homewordItemDescription() {
    if (!_.isEmpty(dig(this.homewordItem, 'elements'))) {
      return `\
---
[復路]
${this.homewordItem.description()}\
`;
    }
  }

  otherItemsDescription() {
    const items = this.otherOrderItems();
    if (_.isEmpty(items)) {
      return [];
    } else {
      return _.map(
        items,
        item => `\
---
${item.description()}\
`
      );
    }
  }

  description() {
    let d = _.compact([
      this.flightItemDescription(),
      this.hotelItemDescription(),
      this.outwordItemDescription(),
      this.homewordItemDescription()
    ]);
    d = d.concat(this.otherItemsDescription());
    return d.join('\n\n');
  }

  traceItemDescriptions() {
    return Object.fromEntries(
      _.map(
        _.filter(this.orderItems, item => item.traceId),
        item => [item.traceId, item.mappingDescription()]
      )
    );
  }

  oldFlightItemDescription() {
    if (!_.isEmpty(this.flight)) {
      return `\
[海外]
${this.flight}
代金：${formatPrice(this.flight_price)}
手数料：${formatPrice(this.flight_fee)}\
`;
    }
  }

  oldHotelItemDescription() {
    if (!_.isEmpty(this.hotel_name)) {
      return `\
[ホテル]
${this.hotel_name}
代金：${formatPrice(this.hotel_price)}\
`;
    }
  }

  oldOutwordItemDescription() {
    if (!_.isEmpty(this.outword)) {
      return `\
[往路]
${this.outword}
代金：${formatPrice(this.outword_price)}
手数料：${formatPrice(this.outword_fee)}\
`;
    }
  }

  oldHomewordItemDescription() {
    if (!_.isEmpty(this.homeword)) {
      return `\
[復路]
${this.homeword}
代金：${formatPrice(this.homeword_price)}
手数料：${formatPrice(this.homeword_fee)}\
`;
    }
  }

  oldDescription() {
    return _.compact([
      this.oldFlightItemDescription(),
      this.oldHotelItemDescription(),
      this.oldOutwordItemDescription(),
      this.oldHomewordItemDescription()
    ]).join('\n\n');
  }

  hotelReservations() {
    const urls = _.map(this.orderItems, item => {
      return _.map(item.elements, e => {
        if (e.type !== 'hotel') {
          return null;
        }
        return {
          reserveUrl: e.reserveUrl,
          singleReserveUrl: this._toSingleReserveUrl(e.reserveUrl),
          alternativePlanUrl: this._toAlternativePlanUrl(e.reserveUrl),
          rakutenTravelRConnectBookingSucceed: e.rakutenTravelRConnectBookingInfos.length === e.roomNum
        };
      });
    });
    return _.compact(_.flatten(urls));
  }

  packageBookingUrl() {
    const item = _.first(this.orderItems);
    if (item) {
      return item.packageBookingUrl;
    }
  }

  handleAddItem() {
    this.orderItems.push(new OrderItem(_.merge(this._itemOptions(), { isEditing: true, status: 3 }))); // 商品追加時のステータスのデフォルト値は要予約の 3 をセットする
    return app.render();
  }

  _toSingleReserveUrl(original) {
    if (original) {
      return original.replace(/f_otona_su=\d/i, 'f_otona_su=1');
    }
  }

  _toAlternativePlanUrl(original) {
    if (!original) {
      return;
    }

    const url = new URL(original);

    if (!url.searchParams.get('f_hi1')) {
      return;
    }
    if (!url.searchParams.get('f_hi2')) {
      return;
    }

    const f_no = url.searchParams.get('f_no');
    const f_otona_su = url.searchParams.get('f_otona_su');
    const f_s1 = url.searchParams.get('f_s1');
    const f_s2 = url.searchParams.get('f_s2');
    const f_y1 = url.searchParams.get('f_y1');
    const f_y2 = url.searchParams.get('f_y2');
    const f_y3 = url.searchParams.get('f_y3');
    const f_y4 = url.searchParams.get('f_y4');
    const f_heya_su = url.searchParams.get('f_heya_su');
    const f_nen1 = url.searchParams.get('f_hi1').split('-')[0];
    const f_tuki1 = parseInt(url.searchParams.get('f_hi1').split('-')[1]);
    const f_hi1 = parseInt(url.searchParams.get('f_hi1').split('-')[2]);
    const f_nen2 = url.searchParams.get('f_hi2').split('-')[0];
    const f_tuki2 = parseInt(url.searchParams.get('f_hi2').split('-')[1]);
    const f_hi2 = parseInt(url.searchParams.get('f_hi2').split('-')[2]);

    return `\
https://hotel.travel.rakuten.co.jp/hotelinfo/plan/\
?f_no=${f_no}&f_teikei=&f_flg=PLAN&f_otona_su=${f_otona_su}&f_s1=${f_s1}\
&f_s2=${f_s2}&f_y1=${f_y1}&f_y2=${f_y2}&f_y3=${f_y3}&f_y4=${f_y4}&f_kin=\
&f_kin2=&f_heya_su=${f_heya_su}&f_nen1=${f_nen1}&f_tuki1=${f_tuki1}&f_hi1=${f_hi1}\
&f_nen2=${f_nen2}&f_tuki2=${f_tuki2}&f_hi2=${f_hi2}&f_hak=&f_tel=&f_target_flg=\
&f_tscm_flg=&f_p_no=&f_custom_code=&f_search_type=&f_service=&f_campaign=&f_camp_id=&f_static=1&f_tel=\
`;
  }

  handleCopyItem(item) {
    const clone = R.clone(item);
    clone.id = null;
    clone.traceId = null;
    clone.isEditing = true;
    clone.billedAt = null;
    clone.jobType = 'reserve';
    clone.status = 9; //NEED_INSTRUCTION = 9 # 発券の指示
    const originalPrices = _.map(item.price.originalPrices, function (op) {
      const cloneOp = R.clone(op);
      cloneOp.originalPriceTraceId = null;
      return cloneOp;
    });
    const details = _.map(item.price.priceDetails, function (d) {
      const cloneDetail = R.clone(d);
      cloneDetail.detailTraceId = null;
      return cloneDetail;
    });

    clone.price = new OrderItemPrice({
      price: item.price.price,
      originalPrice: item.price.originalPrice,
      refund: item.price.refund,
      margin: item.price.margin,
      marginType: item.price.marginType,
      sectionNum: item.price.sectionNum,
      bulkTicketIds: item.price.bulkTicketIds,
      bulkTicketFragmentIds: item.price.bulkTicketFragmentIds,
      shareholderTickets: item.price.shareholderTickets,
      orderItemOriginalPrices: originalPrices,
      orderItemPriceDetails: details
    });

    const index = this.orderItems.indexOf(item);
    this.orderItems.splice(index + 1, 0, clone);
    return app.render();
  }

  handleRemoveItem(item) {
    this.deletedItems.push(item);
    const index = this.orderItems.indexOf(item);
    if (index > -1) {
      this.orderItems.splice(index, 1);
      if (this.hotelItem && this.hotelItem.id === item.id) {
        this.hotelItem = null;
      }
      if (this.flightItem && this.flightItem.id === item.id) {
        this.flightItem = null;
      }
      if (this.outwordItem && this.outwordItem.id === item.id) {
        this.outwordItem = null;
      }
      if (this.homewordItem && this.homewordItem.id === item.id) {
        this.homewordItem = null;
      }
      return app.render();
    }
  }

  _itemOptions() {
    return {
      serviceId: this.serviceId,
      showFee: this.showFee,
      marginTypes: this.marginTypes,
      shippingCategoryOptions: this.shippingCategoryOptions,
      wifiProviderOptions: this.wifiProviderOptions,
      carTypeOptions: this.carTypeOptions,
      carProviderOptions: this.carProviderOptions,
      billing: this.billing
    };
  }

  isNeedReCalcMarginAmount() {
    return this.orderItems.some(item => item.isNeedReCalcMarginAmount());
  }
}
Order.initClass();

module.exports = Order;
